<template>
  <b-modal
    size="md"
    hide-footer
    v-model="show"
    :title="`Edição da Configuração`"
    @hidden="cancelar"
  >
    <b-card>
      <b-row>
        <b-col cols="12">
          <div><span class="font-weight-bold">Configuração:</span> {{ configuracao.tituloPropriedade }}</div>
        </b-col>
      </b-row>
    </b-card>
    <b-form @submit.prevent="salvar">
      <b-form-group>
        <div class="col-12 d-flex justify-content-end">
          <b-button variant="primary" size="sm" @click="openPessoaModal">
            <b-icon icon="plus-circle" />
          </b-button>
        </div>
      </b-form-group>
      <b-table striped hover small :items="pessoas" :fields="fields">
        <template #cell(actions)="data">
          <b-button size="sm" variant="danger" @click="removePessoa(data.item)">
            <b-icon icon="trash" />
          </b-button>
        </template>
      </b-table>
      <b-form-row class="d-flex justify-content-center">
        <b-button type="submit" size="sm" pill variant="success">
          <b-icon icon="check-circle" />
        </b-button>
        <b-button size="sm" pill variant="danger" @click="cancelar" class="ml-2">
          <b-icon icon="x-circle" />
        </b-button>
      </b-form-row>
    </b-form>

    <b-modal id="pessoaModal" ref="pessoaModal" size="xl" hide-footer title="Pessoa">
      <PessoaList @onDblClickPessoa="handleSelectPessoa" />
    </b-modal>
  </b-modal>
</template>

<script>
import ConfiguracaoSistemaService from "@/core/api/ConfiguracaoSistemaService";
import Swal from "sweetalert2";
import PessoaList from "@/modules/cadastros/pessoa/PessoaList.vue";

export default {
  components: {
    PessoaList,
  },
  props: {
    configuracao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: true,
      pessoas: [],
      fields: [
        { key: 'nome', label: 'Pessoa' },
        { key: 'actions', label: '', class: 'text-center' },
      ],
    };
  },
  methods: {
    openPessoaModal() {
      this.$refs.pessoaModal.show();
    },
    handleSelectPessoa(pessoa) {
      const exists = this.pessoas.some(p => p.id === pessoa.id);
      if (!exists) {
        this.pessoas.push(pessoa);
      } else {
        this.$bvToast.toast('Pessoa já adicionada.', {
          title: 'Atenção',
          variant: 'warning',
          solid: true,
        });
      }
      this.$refs.pessoaModal.hide();
    },
    removePessoa(pessoa) {
      this.pessoas = this.pessoas.filter(p => p.id !== pessoa.id);
    },
    async salvar() {
      if (this.pessoas.length === 0) {
        this.$bvToast.toast("Adicione ao menos uma pessoa.", {
          title: "Erro",
          variant: "danger",
          solid: true,
        });
        return;
      }

      const valorPropriedade = this.pessoas.map(p => p.id).join(';');

      const payload = {
        id: this.configuracao.id,
        valorPropriedade,
      };

      try {
        await ConfiguracaoSistemaService.atualizarConfiguracao(payload);
        this.$emit('salvo');
        await Swal.fire({
          title: 'Sucesso',
          text: 'Configuração salva com sucesso!',
          icon: 'success',
          confirmButtonText: 'OK',
        });
      } catch (error) {
        console.error('Erro ao salvar configuração:', error);
        this.$bvToast.toast('Erro ao salvar configuração', {
          title: 'Erro',
          variant: 'danger',
          solid: true,
        });
      }
    },
    cancelar() {
      this.$emit('close');
    },
    async carregarDadosIniciais() {
      if (this.configuracao.valorPropriedade) {
        const pessoaIds = this.configuracao.valorPropriedade.split(';').map(id => parseInt(id, 10));
        try {
          this.pessoas = pessoaIds.map(id => {
            return { id, nome: `${id}` };
          });
        } catch (error) {
          console.error('Erro ao carregar pessoas:', error);
        }
      }
    },
  },
  mounted() {
    this.carregarDadosIniciais();
  },
};
</script>

<style scoped>
.font-weight-bold {
  font-weight: bold;
}
</style>
